import { forwardRef, useContext } from '@wordpress/element';
import { Context } from './context';
import * as Styled from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const Separator = forwardRef(function UnforwardedSeparator(props, ref) {
  const menuContext = useContext(Context);
  if (!menuContext?.store) {
    throw new Error('Menu.Separator can only be rendered inside a Menu component');
  }
  return /*#__PURE__*/_jsx(Styled.Separator, {
    ref: ref,
    ...props,
    store: menuContext.store,
    variant: menuContext.variant
  });
});